import { trackBookingFlowContext, useBookingCars } from 'noddi-web';
import { useEffect } from 'react';
import { useBookingSummaryServiceDepartment } from './useBookingSummaryServiceDepartment';

// Tags the OpenPanel session with plates + executing department so support can
// find a customer's replay.
export function useTrackMobileBookingFlowContext() {
  const cars = useBookingCars();
  const serviceDepartmentName = useBookingSummaryServiceDepartment().data?.name;

  useEffect(() => {
    trackBookingFlowContext({
      locationType: 'mobile',
      licensePlates: cars.map((car) => car.licensePlate.number),
      serviceDepartmentName
    });
  }, [cars, serviceDepartmentName]);
}
